export const HAS_USED_HUBSPOT = 'has_used_hubspot';
export const ONBOARDING_SEARCH_PARAMS = {
  enroll: true
};
export const SALES_SIGNUP_VIA_PARAM = 'sales-signup';
export const CRM_SIGNUP_VIA_PARAM = 'crm-signup';
export const MARKETING_SIGNUP_VIA_PARAM = 'marketing-signup';
export const SERVICE_SIGNUP_VIA_PARAM = 'service-signup';
export const GENERIC_SIGNUP_VIA_PARAM = 'signup';